module.exports = __webpack_public_path__ + "img/trial4-3.d13d6bc1.png";